"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var H = __importStar(require("preact/hooks"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var ProgressGroupWithLogo = __importStar(require("./O_ProgressGroupWithLogo"));
var FullScreenTakeover = __importStar(require("./T_FullScreenTakeover"));
var LoadingStatus;
(function (LoadingStatus) {
    LoadingStatus["INITIAL"] = "initial";
    LoadingStatus["MIDDLE"] = "middle";
    LoadingStatus["FINAL"] = "final";
})(LoadingStatus || (LoadingStatus = {}));
var Component = function (p) {
    var _a = H.useState(LoadingStatus.INITIAL), status = _a[0], setStatus = _a[1];
    H.useEffect(function () {
        return function () {
            p.onUnMount && p.onUnMount();
        };
    }, []);
    H.useEffect(function () {
        var timer = setTimeout(function () {
            setStatus(function (last) {
                return last === LoadingStatus.INITIAL ? LoadingStatus.MIDDLE : LoadingStatus.FINAL;
            });
        }, 10000);
        return function () { return clearTimeout(timer); };
    }, [status]);
    return (Preact.h(FullScreenTakeover.Component, { onClose: p.onClose, sx: p.sx },
        Preact.h(Box_1.default, { sx: { width: { xs: '215px', sm: '394px' } }, "data-testid": "loading-screen" },
            Preact.h(ProgressGroupWithLogo.Component, { imageUrl: p.logoUrl, statusText: p.statusText[status] }))));
};
exports.Component = Component;
exports.Component.displayName = 'StartupScreen';
